module.exports = __webpack_public_path__ + "img/attachment.f9724a24.png";